/**
 * @description 断言属性（判断设备，系统等）
 *
 */
const NA = navigator.userAgent.toLowerCase();
const phoneAgents = [
  "android",
  "iphone",
  "symbianos",
  "windows phone",
  "ipad",
  "ipod",
  "mobile",
];

// 是否为ios
export const isIos = /iPhone|iPod|iPad|Macintosh|Mac/i.test(NA);

// 是否为Android
export const isAndroid = /Android/i.test(NA) || /Adr/i.test(NA);

// 是否为鸿蒙
export const isHarmony = /OpenHarmony|HUAWEI/i.test(NA);

// 是否为埋堆堆客户端
export const isMdd = /mddios|mddandroid|mddharmony/i.test(NA);

// 是否为微信客户端
export const isWx = /MicroMessenger/i.test(NA);

// 是否为iPhone刘海屏
export const isIosBang =
  isIos && window.screen.height >= 812 && window.devicePixelRatio >= 2;

// 是否为PC
export const isPC = !phoneAgents.some((item) => NA.indexOf(item) > -1);

/**
 * 插入script在页面
 * @param url
 * @param callback
 */
export function loadScript(url) {
  window.loadedScript = window.loadedScript || [];

  return new Promise((resolve, reject) => {
    if (window.loadedScript.includes(url)) {
      resolve({
        code: 1,
        msg: "this script was loaded",
      });
    }
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

    script.onload = function () {
      script.onload = null;
      window.loadedScript.push(url);
      resolve({
        code: 1,
        msg: "script load success!",
      });
    };
  });
}
